import { call, put, takeEvery } from "redux-saga/effects";
import { getNotifications, setNotifications } from "./actions";
import {
  GET_NOTIFICATIONS,
  UPDATE_NOTIFICATIONS,
  UPDATE_ALL_NOTIFICATIONS,
  DELETE_NOTIFY
} from "./actionTypes";
import { deleteNotify, getNotify, patchNotify, putViewAllNotify } from "../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage } from "../../helpers/utils";

function* onUpdateAllNotifications() {
  try {
    yield call(putViewAllNotify);
    yield put(getNotifications());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateNotifications({ payload: params }) {
  try {
    const formData = new FormData();
    formData.append("reviewed", params.reviewed);
    yield call(patchNotify, formData, params.id);
    yield put(getNotifications());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetNotifications() {
  try {
    let response = yield call(getNotify);
    yield put(setNotifications(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteNotification({ payload: id }) {
  try {
    yield call(deleteNotify, id);
    yield put(getNotifications());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* notificationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, onGetNotifications);
  yield takeEvery(UPDATE_NOTIFICATIONS, onUpdateNotifications);
  yield takeEvery(UPDATE_ALL_NOTIFICATIONS, onUpdateAllNotifications);
  yield takeEvery(DELETE_NOTIFY, onDeleteNotification);
}

export default notificationsSaga;
